import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkHelper {
  constructor(private http: HttpClient) {}

  private setParams(queryParams?: { [key: string]: unknown }): HttpParams {
    let params = new HttpParams();
    if (queryParams) {
      for (const key in queryParams) {
        if (Object.prototype.hasOwnProperty.call(queryParams, key) && queryParams[key] !== undefined) {
          const value = queryParams[key];
          if (typeof value === 'string' || typeof value === 'number') {
            params = params.set(key, value.toString());
          } else if (Array.isArray(value)) {
            params = params.set(key, value.join(','));
          }
        }
      }
    }
    return params;
  }

  get<T>(url: string, queryParams?: { [key: string]: unknown }): Observable<T> {
    const params = this.setParams(queryParams);
    return this.http.get<T>(url, { params });
  }

  post<T>(url: string, body: { [key: string]: unknown }): Observable<T> {
    return this.http.post<T>(url, body);
  }

  put<T>(url: string, body: { [key: string]: unknown }): Observable<T> {
    return this.http.put<T>(url, body);
  }

  delete<T>(url: string, body?: { [key: string]: unknown }): Observable<T> {
    const params = this.setParams(body);
    return this.http.delete<T>(url, { params });
  }
}
